import Vue from 'vue';
import moment from 'moment';
import i18n from '../plugins/i18n';

const booleanFormat = (value: boolean, trueLabel: string, falseLabel: string) => {
    moment.locale(i18n.locale);
    return i18n.t(value ? trueLabel : falseLabel);
}

Vue.filter('boolean', (value: boolean, trueLabel: string, falseLabel: string) => {

    return booleanFormat(value, trueLabel || 'labels.yes', falseLabel || 'labels.no');
});
